export default {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--color-bg-paper)',
      borderRadius: '12px',
      border: '1px solid var(--color-border)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
      transition: 'box-shadow 0.2s ease, transform 0.2s ease',

      '&:hover': {
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
    },
  },
};
